module.exports = __webpack_public_path__ + "static/media/materiales.1a1f1631.jpg";